import React from 'react';
import PropTypes from 'prop-types';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';


const PasswordToggle = ({showPassword, onClick}) => (
  <InputAdornment position="end">
    <IconButton
      aria-label={showPassword ? 'Hide password' : 'Show password'}
      onClick={onClick}
      onMouseDown={event => event.preventDefault()} //cause profile form has onblur validation, prevent blur change
      edge="end"
      size="small"
    >
      {showPassword ? <Visibility fontSize="small" /> : <VisibilityOff fontSize="small" />}
    </IconButton>
  </InputAdornment>
);

PasswordToggle.propTypes = {
  showPassword: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default PasswordToggle;
